/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"
import { useContext } from "react"
import {
  BulkUploadContext,
  DRAWER_STATES,
} from "pages/menu/detail/bulkUpload/BulkUploadContext"
import { Button } from "@duxton-web/ui"
import { useTranslations } from "common/utils/i18n"
import { ACTION_TYPE } from "types/delv-platform-api/inventoryCategory"

type PropTypes = {
  onUploadFileToServer: () => void
}

const DrawerFooter = ({ onUploadFileToServer }: PropTypes) => {
  const [
    uploadFileButtonText,
    addToMenuButtonText,
    cancelUploadButtonText,
  ] = useTranslations([
    "bulkUpload.drawers.start.publish",
    "bulkUpload.drawers.start.addToMenu",
    "bulkUpload.drawers.publishing.cancelUploadButton",
  ])
  const { drawerState, actionType } = useContext(BulkUploadContext)
  const isPublishable = drawerState === DRAWER_STATES.PUBLISHABLE

  if (isPublishable || drawerState === DRAWER_STATES.START) {
    return (
      <div>
        <Button
          block
          type="primary"
          onClick={onUploadFileToServer}
          disabled={!isPublishable}
        >
          {actionType === ACTION_TYPE.CREATE
            ? addToMenuButtonText
            : uploadFileButtonText}
        </Button>
      </div>
    )
  }

  if (
    drawerState === DRAWER_STATES.PUBLISHING ||
    drawerState === DRAWER_STATES.PUBLISHING_ERROR_CHECK
  ) {
    return (
      <div>
        <Button type="primary" disabled block>
          {cancelUploadButtonText}
        </Button>
      </div>
    )
  }

  return null
}

export default DrawerFooter
